import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ResizeWindowService } from '../../services/resize-window.service';
import { Subscription } from 'rxjs';
import { UtilsService } from '../../services/utils.service';

@Component({
  selector: 'skeleton-cards-list',
  templateUrl: './skeleton-cards-list.component.html',
  styleUrls: ['./skeleton-cards-list.component.scss']
})
export class SkeletonCardsListComponent implements OnInit, OnDestroy {
  @Input() title1: string = '';
  @Input() title2?: string = '';
  @Input() context: string;
  className = 'skeleton-cards-list';
  theme: string = 'marketplace-default';
  width: number = 0;
  times: number[] = [];
  arraySubscriptions: Subscription[] = [];

  constructor(
    private resizeWindowService: ResizeWindowService,
    private utilsService: UtilsService
  ) {}

  ngOnInit() {
    this.arraySubscriptions.push(
      this.resizeWindowService.width$.subscribe({
        next: (value: number) => {
          this.width = value;
          this.times = this.prepareSkeleton(this.width);
        },
        error: (err) => {
          console.error(err);
        }
      })
    );
  }

  prepareSkeleton(width) {
    return this.utilsService.prepareCards(width);
  }

  ngOnDestroy() {
    this.arraySubscriptions.forEach((subscription) => subscription.unsubscribe());
  }
}